var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.announcement.announcementTitle
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "entry-ticker-content entry-ticker-text",
            on: { mousemove: _vm.pause, mouseleave: _vm.start },
          },
          [
            _c("a-icon", {
              staticStyle: { "padding-left": "16px" },
              attrs: { type: "exclamation-circle", theme: "filled" },
            }),
            _c("b", [
              _vm._v("【" + _vm._s(_vm.announcement.announcementTitle) + "】"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  position: "relative",
                  flex: "1",
                  overflow: "hidden",
                  "min-height": "48px",
                },
              },
              [
                _c("div", {
                  ref: "tickerText",
                  staticClass: "entry-ticker-content__swiper",
                  style: { transform: `translate(${_vm.count * -1}px, -50%)` },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.announcement.announcementContent.replace(
                        /<\/?.+?\/?>/g,
                        ""
                      )
                    ),
                  },
                }),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "entry-ticker-btn" },
          [
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.open } },
              [_vm._v(_vm._s(_vm.$t("common_btn_renewal")))]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }